module.exports = __webpack_public_path__ + "static/media/ADDVA_VOUCH.bb170397.svg";